export enum PasswordMode {
  RESET = 'reset',
  CREATE = 'create',
}
